import { TypographyOptions } from '@mui/material/styles/createTypography';

import { pxToRem, responsiveFontSizes } from 'utils/getFontValue';

const FONT_PRIMARY = "'Sporting Grotesque', sans-serif";
const FONT_SECONDARY = 'FavoritPro-Medium, sans-serif';

const typography: TypographyOptions = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
        fontWeight: 700,
        lineHeight: 80 / 64,
        fontSize: pxToRem(40),
        position: 'relative',
        ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
        '::before': {
            content: '',
            borderRadius: '50%',
            background: '#f7c754',
            height: pxToRem(40 * 2),
            width: pxToRem(40 * 2),
            position: 'absolute',
            top: '-15px',
            left: '-25px',
            zIndex: '-1',
        },
    },
    h2: {
        fontWeight: 700,
        lineHeight: 64 / 48,
        fontSize: pxToRem(32),
        ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
        '::before': {
            content: '""',
            borderRadius: '50%',
            background: '#f7c754',
            height: pxToRem(32 * 2),
            width: pxToRem(32 * 2),
            position: 'absolute',
            top: '-15px',
            left: '-25px',
            zIndex: '-1',
        },
    },
    h3: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(20),
        position: 'relative',
        ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
        '::before': {
            content: '""',
            borderRadius: '50%',
            background: '#f7c754',
            height: pxToRem(24 * 2),
            width: pxToRem(24 * 2),
            position: 'absolute',
            top: '-15px',
            left: '-25px',
            zIndex: '-1',
        },
    },
    h4: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
        position: 'relative',
        ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
    },
    h5: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(16),
        ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
    },
    h6: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 700,
        lineHeight: 28 / 18,
        fontSize: pxToRem(14),
        ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
    },
    subtitle1: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(16),
    },
    subtitle2: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 600,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    body1: {
        fontFamily: FONT_SECONDARY,
        lineHeight: 1.5,
        fontSize: pxToRem(16),
    },
    body2: {
        fontFamily: FONT_SECONDARY,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    caption: {
        fontFamily: FONT_SECONDARY,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
    },
    overline: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        letterSpacing: 1.1,
        textTransform: 'uppercase',
    },
    button: {
        fontFamily: FONT_SECONDARY,
        fontWeight: 700,
        lineHeight: 24 / 12,
        fontSize: pxToRem(12),
        textTransform: 'uppercase',
        letterSpacing: '1px',
    },
};

export default typography;
